import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export type PasswordInputProps = Omit<React.ComponentProps<typeof Input>, 'type'>;

/** Input de senha com botão de mostrar/ocultar. */
export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [visivel, setVisivel] = React.useState(false);
    const rotulo = visivel ? 'Ocultar senha' : 'Mostrar senha';

    return (
      <div className="relative">
        <Input ref={ref} type={visivel ? 'text' : 'password'} className={cn('pr-10', className)} {...props} />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 h-9 w-9 -translate-y-1/2 text-muted-foreground hover:bg-transparent hover:text-foreground"
          onClick={() => setVisivel((atual) => !atual)}
          aria-label={rotulo}
          title={rotulo}
        >
          {visivel ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </Button>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
